export class CacheRepo<T> {

    constructor() { }

    /** Gets the cache for the given key. */
    async get(key: string): Promise<T | null> {
        const cached = localStorage.getItem(key);

        if (!cached) return null;
        const { data, expiry } = JSON.parse(cached);
        if (expiry && Date.now() > expiry) {
            localStorage.removeItem(key);
            return null;
        }

        return data;
    }

    /** Sets the cache for the given key. i.e. overwrites the cache with the new data. */
    async set(key: string, data: T, ttl?: number): Promise<void> {
        const cacheData = {
            data,
            expiry: ttl ? Date.now() + ttl : null
        };
        localStorage.setItem(key, JSON.stringify(cacheData));
    }

    /** Updates the existing cache item by merging the given data. If the cache is not found, it will be created. */
    async update(key: string, data: T, ttl?: number): Promise<void> {
        const cached = await this.get(key);
        if (cached) {
            const updated = { ...cached, ...data } as T;
            const cacheData = {
                data: updated,
                expiry: ttl ? Date.now() + ttl : null
            };
            localStorage.setItem(key, JSON.stringify(cacheData));
        }
    }

    async deleteByPrefix(prefix: string): Promise<void> {
        if (!prefix) return;
        Object.keys(localStorage).forEach((key: string) => {
            if (key.startsWith(prefix)) {
                localStorage.removeItem(key);
            }
        });
    }

    /** Deletes the cache for the given key. */
    async delete(key: string): Promise<void> {
        localStorage.removeItem(key);
    }
}